<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview v-bind:title="'Detail Rekapitulasi Evaluasi Dosen oleh ' + titlePage">
                    <template v-slot:body>
                        <v-card>
                            <v-card-title>
                                <v-spacer></v-spacer>
                                <v-text-field v-model="search" label="Search" single-line hide-details>
                                </v-text-field>
                            </v-card-title>
                            <v-data-table :headers="headers" :items="rekap" :search="search">
                                <template v-slot:item.no="{ item ,index }">
                                    {{ index + 1 }}
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <!-- <router-link :to="{ name: 'form-student-list', params: { item: JSON.stringify(item) } }">
                        <ButtonComponent colors="#3751E4" name="edit" dataTitleTooltip="Edit" />
                        </router-link> -->
                                    <ButtonComponent colors="#EF4848" name="hapus" @click.native="deleteData(item.key)"
                                        dataTitleTooltip="Hapus" />
                                </template>
                            </v-data-table>
                        </v-card>
                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>

<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import axios from "axios";

export default {
    data() {
        return {
            rekap: [
                {
                    no: 1,
                    nip: 'Achmad Taufiqoerrochman',
                    name: 'Statistika',
                    materi: 85,
                    motivator: 90.00,
                    aplikasi: 78,
                    moral: 89
                },
                {
                    no: 2,
                    nip: 'Adji Samekto',
                    name: 'Algoritma',
                    materi: 85,
                    motivator: 70.00,
                    aplikasi: 78,
                    moral: 89
                },
                {
                    no: 3,
                    nip: 'Agung Pramono',
                    name: 'Diskrit',
                    materi: 85,
                    motivator: 90.00,
                    aplikasi: 78,
                    moral: 89
                },
                {
                    no: 4,
                    nip: 'Agung Setiawan',
                    name: 'Struktur Data',
                    materi: 85,
                    motivator: 87.00,
                    aplikasi: 78,
                    moral: 89
                },
                {
                    no: 5,
                    nip: 'Danpaspampres',
                    name: 'Mobile',
                    materi: 85,
                    motivator: 98.00,
                    aplikasi: 78,
                    moral: 89
                },
            ],
            search: "",
            headers: [
                { text: "No", value: "no", align: "center", sortable: false },
                { text: "NIP", value: "nip", align: "center" },
                { text: "Nama", value: "name", align: "center" },
                { text: "Materi", value: "materi", align: "center" },
                { text: "Motivator", value: "motivator", align: "center" },
                { text: "Aplikasi", value: "aplikasi", align: "center" },
                { text: "Moral", value: "moral", align: "center" },
            ],
            dataLogin: JSON.parse(localStorage.getItem("dataLogin"),),
            titlePage: ''
        };
    },
    components: {
        KTCodePreview,
        ButtonComponent,
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Evaluasi Dosen" },
        ]);

        // this.getData();

        this.titlePage = this.$route.name;

        // if (this.$route.params.createOrUpdate) {
        //     // this.$swal(`${this.$route.params.createOrUpdate}`);
        // }
    },
    methods: {
        async getData() {
            try {
                const result = await axios.get('edops-student/quetion');
                this.rekap = result.data.data;
            } catch (err) {
        this.$swal(`Eror Store Data`);
            }
        },
        // refreshData(result, alert) {
        //     if (result.data.data.meta.code == 200) {
        //         this.$swal('Success ${alert} Data');
        //         this.getData()
        //     } else {
        // this.$swal(`Eror Store Data`);
        //     }
        // },
    },
};

</script>